/**
 * Stop the browser's native drag-and-drop on app content: images, avatars,
 * icons, videos and links would otherwise lift out as a ghost image or URL
 * when dragged (for example while panning in the image editor).
 *
 * Text selections stay draggable (their dragstart target is a Text node), and
 * so does anything explicitly marked draggable="true" or [data-allow-drag].
 * In-app reordering uses pointer events, so it isn't affected.
 */
export function blockNativeDrag() {
  document.addEventListener(
    "dragstart",
    (e) => {
      const t = e.target;
      if (!(t instanceof Element)) return;
      if (t.closest('[draggable="true"],[data-allow-drag]')) return;
      e.preventDefault();
    },
    { capture: true },
  );
}
